export default {"src":"/_next/static/media/film.e5bd5695.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};